import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { IGpsOutsideProjectReportSettings } from 'types/gpsOutsideProjectReportSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useGpsOutsideProjectReportSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof IGpsOutsideProjectReportSettings>(
      keysAndPayloads: { key: K; payload: IGpsOutsideProjectReportSettings[K] }[]
    ) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.gpsOutsideProjectReport);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('gpsOutsideProjectReport', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
